export default __webpack_public_path__ + "static/media/michael_bonning.828c3534.jpg";